import React, { Suspense, useEffect, useState } from 'react'
import { Route, Switch, useHistory, useLocation } from 'react-router-dom'
import auth from './firebase-config'
import routes from './routes'
import axios from './store/axios-secure'
import SecureRoute from './components/Authentication/SecureRoute'
import Loader from './components/Common/Loader'
import { useAuthState } from 'react-firebase-hooks/auth'

import Navbar from './components/Structure/Navbar'
import AppContext from './store/context'

import './stylesheet/common.scss'
import 'react-datepicker/dist/react-datepicker.css'
import ErrorPage from './components/Common/ErrorPage'
import ChatBoxModal from './components/ChatFeature/ChatBoxModal'
import io from 'socket.io-client'
// const socket = io('http://localhost:5000') // Connect to your server's URL
// const socket = io(process.env.REACT_APP_SOCKET_URL, { path: '/s2/socket.io' })

const App = () => {
    const location = useLocation()
    const history = useHistory()
    const [user, loading, error] = useAuthState(auth)
    const [isError, setIsError] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [verified, setVerified] = useState(null)
    const [profileRef, setProfileRef] = useState()
    const [profilePicture, setProfilePicture] = useState()
    const [initialClientList, setInitialClientList] = useState([])
    const [clientList, setClientList] = useState([])
    const [chatContacts, setChatContacts] = useState([])
    const [chatClients, setChatClients] = useState([])
    const [trainerId, setTrainerId] = useState('')
    const [trainerSettings, setTrainerSettings] = useState({})

    console.log('test')
    const userSettings = {
        verified: verified,
        profileRef: profileRef,
        setProfileRef: setProfileRef,
        profilePicture: profilePicture,
        initialClientList: initialClientList,
        clientList: clientList,
        setClientList: setClientList,
        setInitialClientList: setInitialClientList,
        trainerSettings,
        setTrainerSettings,
    }
    const handleTrainerRedirect = async () => {
        try {
            const response = await axios.post(`trainers/add`, {
                timezone: new Date().getTimezoneOffset(),
            })
            const profileRef = response?.data?.profileRef
            setVerified(response?.data?.isVerified)
            setProfileRef(profileRef)
            if (response?.data?.isVerified) {
                const clientDataResponse = await axios.get(
                    '/trainers/users?active=true',
                )
                let newClientList = clientDataResponse?.data?.clients
                setTrainerSettings(clientDataResponse.data?.settings)
                let finalList = {
                    NoProgram: [],
                    Paused: [],
                }
                newClientList.forEach((client) => {
                    if (client?.currentProgramName && !client?.isPaused) {
                        let newGroup =
                            finalList[client.currentProgramName] || []
                        newGroup.push(client)
                        finalList[client.currentProgramName] = newGroup
                    } else if (client.isPaused) {
                        let newGroup = finalList['Paused'] || []
                        newGroup.push(client)
                        finalList['Paused'] = newGroup
                    } else {
                        let newGroup = finalList['NoProgram'] || []
                        newGroup.push(client)
                        finalList['NoProgram'] = newGroup
                    }
                })
                let pausedProgram = finalList['Paused']
                delete finalList.Paused
                finalList['Paused'] = pausedProgram
                let noProgram = finalList['NoProgram']
                delete finalList.NoProgram
                finalList['NoProgram'] = noProgram
                setInitialClientList(Object.entries(finalList))
                setClientList(Object.entries(finalList))

                // const response = await axios.get('/chat/getChatsAndClients') //for chat
                // let trainerId = response.data?.trainerId
                // // console.log("trainerId............", trainerId)
                // if (trainerId) {
                //     socket.emit('trainerIdForRoom', trainerId)
                // }
                // setChatClients(response.data?.clients)
                // setChatContacts(response.data?.chats)
            }
            if (!profileRef && location.pathname !== '/trainer-onboarding') {
                history.push('/trainer-onboarding')
            } else if (
                profileRef &&
                location.pathname === '/trainer-onboarding'
            ) {
                history.push('/')
            }
        } catch (error) {
            setIsError(true)
        }
        setIsLoading(false)
    }
    const handleChats = async () => {
        try {
            const response = await axios.get('/chat/getChatsAndClients') //for chat
            let Id = response.data?.trainerId
            setTrainerId(Id)
            // console.log("trainerId............", trainerId)
            // if (Id) {
            //     // // socket.emit('trainerIdForRoom', trainerId)
            //     // console.log(Id, type)
            //     // let type = 'trainer'
            //     // socket.emit('join_trainerRoom', { Id, type })
            // }
            setChatClients(response.data?.clients)
            setChatContacts(response.data?.chats)
        } catch (error) {
            console.log('error while getting chats..', error)
        }
    }

    useEffect(async () => {
        if (user) {
            setIsLoading(true)
            if (user.photoURL) {
                setProfilePicture(user.photoURL.replace('=s96-c', '=s400-c'))
            } else {
                setProfilePicture(
                    'https://lh3.googleusercontent.com/a/AATXAJz6amxXy85ur0oMRki-E6mWZw4y7qz8GhTKxhD_=s400-c',
                )
            }
            handleTrainerRedirect()
            handleChats()
        }
    }, [user])
    const menu = routes.map((route, index) => {
        if (route.secure) {
            return (
                <SecureRoute
                    key={index}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    role={route.role}
                    component={route.component}
                />
            )
        } else {
            return (
                <Route
                    key={index}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    render={(props) => <route.component {...props} />}
                />
            )
        }
    })

    const updateContacts = (newContacts) => {
        setChatContacts(newContacts)
    }

    return (
        <AppContext.Provider value={userSettings}>
            <Suspense fallback={<Loader fullscreen />}>
                {isLoading ? (
                    <Loader fullscreen />
                ) : isError ? (
                    <ErrorPage />
                ) : (
                    <>
                        {user && location.pathname != '/user' && <Navbar />}
                        <main className="main">
                            <Switch>{menu}</Switch>
                        </main>
                        {verified == true &&
                            user &&
                            location.pathname != '/user' && (
                                <ChatBoxModal
                                    clients={chatClients}
                                    contacts={chatContacts}
                                    setClients={setChatClients}
                                    setContacts={setChatContacts}
                                    updateContacts={updateContacts}
                                    // socket={socket}
                                    trainerId={trainerId}
                                />
                            )}
                    </>
                )}
            </Suspense>
        </AppContext.Provider>
    )
}

export default App
